import React from "react";
import { withRouter } from "react-router-dom";
import { Container, CardView } from "./style";
import { TICKET } from "../../constants/urls";
import { convertDateTimeToFormattedTime } from "../../lib/timeFormat";

const ItemCard = ({
  id,
  title,
  created_at,
  state,
  history,
  unread_ticket_messages
}) => {
  const date = created_at.split(" ");
  return (
    <Container
      onClick={() => {
        history.push(`${TICKET}/${id}`);
        //go to ticket thread page
      }}
    >
      <CardView>
        <div className="header-row">
          <div className="date">
            {date[0]} - {convertDateTimeToFormattedTime(created_at)}
          </div>
          <div className="left-part">
            <div className="state">{state}</div>
            {unread_ticket_messages > 0 && (
              <div className="counts">{unread_ticket_messages}</div>
            )}
          </div>
        </div>

        <div className="text">{title.split("\n").join("\n")}</div>
      </CardView>
    </Container>
  );
};

export default withRouter(ItemCard);
